<template>
  <date-picker v-model="date" :config="options" @input="update" />
</template>
<script>
import DatePicker from 'vue-bootstrap-datetimepicker'

export default {
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: [Object, String],
      default: null,
    },
    format: {
      type: String,
      default: 'DD.MM.YYYY',
    },
    parseFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
  },
  data() {
    return {
      date: this.$moment(this.value, 'YYYY-MM-DD').format(this.format),
      options: {
        locale: 'sk',
        format: this.format,
        useCurrent: false,
      },
    }
  },
  methods: {
    update() {
      this.$emit(
        'input',
        this.date
          ? this.$moment(this.date, this.format).format(this.parseFormat)
          : null,
      )
    },
  },
}
</script>
